<template>
<div id="qrcodeMirror" class="qrcodeMirror">
  <div id="header-navi" class="header-navi">
    <router-link :to="{ name: 'home'}" class="header-navi__back">Back</router-link>
    <h2 class="header-navi__ttl">QRCode Reader</h2>
  </div>
  <div class="qrcodeMirror__wrapper">
    <video id="video" width="100%" height="100%" autoplay="1"></video>
    <div class="qrcodeMirror__wrapper__canvas">
      <canvas id="canvas"></canvas>
    </div>
  </div>
  <Modal
    v-if="showModal"
    @close="showModal = false"
    :content="readURL"
    is-navi="true"
    :modalObject="modalObject"
    :href="this.readURL" />
  <div @click="isMirrorMenuModal = true" class="mirrorGlobalMenu">
    <img src="@/assets/images/mirror/commons/commons-menu.svg" alt="Menu">
  </div>
  <MirrorMenuModal
    v-if="isMirrorMenuModal"
    @closeMenu="isMirrorMenuModal = false" />
  <ScreenSaverModal
    v-if="isScreenSaver"
    @closeScreenSaver="isScreenSaver = false" />
</div>
</template>

<script>
/* eslint-disable */

import jsQR from 'jsqr'
import Modal from '@/components/Modal'
import MirrorMenuModal from '@/components/mirror/MirrorMenuModal'
import ScreenSaverModal from '@/components/mirror/ScreenSaverModal'
import ScreenSaver from '@/assets/class/ScreenSaver'
import customMgr from '@/modules/CustomManager.js'

export default {
  mixins: [ScreenSaver],
  components: {
    Modal,
    MirrorMenuModal,
    ScreenSaverModal
  },
  beforeRouteEnter (to, from, next) {
    next()
  },
  data () {
    return {
      showModal: false,
      inputCustomID: '',
      readURL: '',
      video: '',
      stream: null,
      enterFrame: null,
      modalObject: {
        title: 'カスタム画面に移動', content: '', routerLink: { name: 'mirror-custom', query: { customid: '' }}, href: '', showNo: true, showOk: false
      },
      isMirrorMenuModal: false
    }
  },
  metaInfo: {
    meta: [
      { name: 'viewport', content: 'width=1080,user-scalable=no' }
    ]
  },
  watch: {
    showModal: {
      handler () {
        if(this.showModal === false) this.startEnterframe()
      }
    }
  },
  mounted () {
    navigator.getUserMedia = navigator.getUserMedia || navigator.webkitGetUserMedia || window.navigator.mozGetUserMedia
    this.video = this.$el.querySelector('video')

    this.startEnterframe()

  },
  beforeDestroy() {
    clearInterval(this.enterFrame)
  },
  methods: {
    startEnterframe () {
      navigator.getUserMedia({
          video: true,
          audio: false
        },
        (stream) => {
          this.video.srcObject = stream
          this.localStream = stream
        },
        (err) => {}
      )

      const pattern = new RegExp(
        '^(https?:\\/\\/)?((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|((\\d{1,3}\\.){3}\\d{1,3}))(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*(\\?[;&a-z\\d%_.~+=-]*)?(\\#[-a-z\\d_]*)?$',
        'i')
      const canvas = this.$el.querySelector('canvas')
      const ctx = canvas.getContext('2d')

      this.enterFrame = setInterval(()=> {
        if (this.localStream && this.video !== '') {

          const w = this.video.offsetWidth
          const h = this.video.offsetHeight
          canvas.setAttribute('width', w)
          canvas.setAttribute('height', h)
          ctx.drawImage(this.video, 0, 0, w, h)

          const imgData = ctx.getImageData(0, 0, w, h)
          const qrcodeData = jsQR(imgData['data'], w, h)

          // qrcodeDataが空でなく、URLが含まれている
          if(qrcodeData !== null && pattern.test(qrcodeData['data'])) {
            const customID = getParameterByName('customid', qrcodeData['data'])

            if(customID !== '') {
              this.modalObject = {
                title: 'カスタム画面に移動',
                content: '',
                routerLink: {
                  name: 'mirror-custom',
                  query: { customid: customID }
                },
                href: '',
                showNo: true,
                showOk: false
              }
            }else {
              this.modalObject = {
                title: '不正なQRコードです',
                content: 'QRコードにカスタムIDが含まれていません。',
                routerLink: '',
                href: '',
                showNo: false,
                showOk: true
              }
            }

            clearInterval(this.enterFrame)
            this.readURL = qrcodeData['data']
            this.showModal = true
          }
        }
      }, 500)
    }
  }
}

function getParameterByName(name, targetURL) {
  name = name.replace(/[\[]/, "\\\[").replace(/[\]]/, "\\\]")

  // キーと値を含む正規表現文字列を生成
  const regexStr = "[\\?&]" + name + "=([^&#]*)"
  // 正規表現文字列から正規表現を生成
  const regex = new RegExp(regexStr)
  // クエリから正規表現を使って検索する
  const results = regex.exec(targetURL)

// 結果がなかったとき
  if (results === null) return ''
  else return decodeURIComponent(results[1].replace(/\+/g, " "))
}

</script>

<style lang="scss" scoped>
.header-navi {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
}
.qrcodeMirror {
  position: fixed;
  width: 100%;
  height: 100%;
  background: $black;

  &__wrapper {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;

    &__card {
      background: $base-white;
      width: 45vw;
      padding: 30px;
      display: block;
      position: absolute;
      bottom: 25vh;


      &__inner {
        &__lead {
          font-size: 20px;
          margin-bottom: 20px;
          line-height: 1.4;
        }

        &__input {
          width: 100%;
          height: 50px;
          padding: 0 60px 0 10px;
          font-size: 16px;
          border: 1px solid #CCC;
          margin-bottom: 20px;
        }

        &__button {
          border: none;
          outline: none;
          width: 100%;
          font-size: 20px;
          color: $base-white;
          padding: 15px 10px;
          background: #111;
        }
      }
    }
  }
  #video {
    width: 100%;
    height: auto;
    opacity: 0;
  }
  #canvas {
    display: none;
  }
  .mirrorGlobalMenu {
    @include mirrorMenuBtn;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/mirror/MirrorQRcode.vue